import { produce } from 'immer';
import { compressSync } from 'fflate';
/** Compress a schema object the same way it is stored on a device (fflate). */
export function compressSchema(schema) {
    return compressSync(new TextEncoder().encode(JSON.stringify(schema)), { level: 6, mem: 8 });
}
/**
 * Build a complete IDeviceData from a static resource bundle. P/PR/PP get their
 * origin set equal to the loaded data (i.e. "read out" — no pending changes),
 * matching the granular data/*\/readOut reducer behaviour. The compressed schema
 * is derived here, so callers no longer have to compress it themselves.
 */
export function createDeviceDataFromResources(res, opts) {
    return {
        serialNumber: opts.serialNumber ?? createInitialDeviceData().serialNumber,
        uri: opts.uri,
        schema: res.schema,
        schemaCompressed: compressSchema(res.schema),
        source: opts.source ?? 'app',
        scanTime: 'unknown',
        data: {
            V: res.V,
            VP: res.VP,
            CP: res.CP,
            P: res.P,
            PR: res.PR,
            PP: res.PP,
        },
        origin: {
            P: res.P,
            PR: res.PR,
            PP: res.PP,
        },
    };
}
/**
 * Pure factory and transformation helpers for the device data domain model.
 * These encapsulate the lifecycle logic that used to be spread across several
 * reducer cases (initial state, new read, reset changes, write done).
 */
export function createInitialDeviceData() {
    return {
        serialNumber: '00:00:00:00:00:00:00:00',
        uri: null,
        schema: {},
        schemaCompressed: null,
        source: 'unknown',
        scanTime: 'unknown',
        data: {
            V: { V: {} },
            VP: { VP: {} },
            CP: { CP: {} },
            P: { P: {} },
            PR: { PR: {} },
            PP: { PP: {} },
        },
        origin: {
            P: { P: {} },
            PR: { PR: {} },
            PP: { PP: {} },
        },
    };
}
/** Reset before reading a new device: clear schema, data and origin. */
export function prepareForNewRead(d) {
    return produce(d, (draft) => {
        draft.schema = {};
        draft.data = {
            V: { V: {} },
            VP: { VP: {} },
            CP: { CP: {} },
            P: { P: {} },
            PR: { PR: {} },
            PP: { PP: {} },
        };
        draft.origin = {
            P: { P: {} },
            PR: { PR: {} },
            PP: { PP: {} },
        };
        draft.scanTime = 'unknown';
    });
}
/** Discard local changes: restore P/PR/PP from their origin values. */
export function resetChanges(d) {
    return produce(d, (draft) => {
        draft.data.P = draft.origin.P;
        draft.data.PR = draft.origin.PR;
        draft.data.PP = draft.origin.PP;
    });
}
/** After a successful write: the current P/PR/PP become the new origin. */
export function commitWrite(d) {
    return produce(d, (draft) => {
        draft.origin.P = draft.data.P;
        draft.origin.PR = draft.data.PR;
        draft.origin.PP = draft.data.PP;
    });
}
